import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService, UserService } from "app/auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-send-multiple-welcome-email",
  templateUrl: "./send-multiple-welcome-email.component.html",
  styleUrls: ["./send-multiple-welcome-email.component.scss"],
})
export class SendMultipleWelcomeEmailComponent implements OnInit {
  public contentHeader: IContentHeader;
  public userList: any = [];
  public searchKeyword: string = "";
  public categories: string[] = ["Email aziendale", "Email privata"];
  public selectedCategory: string = "Email aziendale";
  public pageBasicText: number = 1;
  public pageSize = 10;
  public filteredUsers: any = [];
  public emailToSend: string[] = [];
  public errorEmailNotSendedUsers: string[] = [];

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public activatedRoute: ActivatedRoute,
    public _userService: UserService,
    public router: Router,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: "MENU.SEND_MULTIPLE_WELCOME_EMAIL",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.SEND_MULTIPLE_WELCOME_EMAIL",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("send_multiple_welcome_email")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.userList = await this._userService.getList("employee", null, 1, "firstname,lastname,complete_name,hash,send_onboarding,private_email,email");
    this.userList = this.userList.filter((user) => user.send_onboarding == 0);
    this.filterUsers();
    this._utilService.hideLoading();
  }

  filterUsers() {
    let items: any = this.userList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((user: any) => user?.complete_name.toLowerCase().includes(keywords));
    }
    this.filteredUsers = items;
  }

  toggleEmailToSend(hash: string) {
    if (this.searchKeyword && this.searchKeyword.length > 0) {
      this.searchKeyword = "";
      this.filterUsers();
    }
    this.searchKeyword = "";
    if (this.emailToSend.includes(hash)) {
      this.emailToSend = this.emailToSend.filter((user_hash: string) => user_hash !== hash);
    } else {
      this.emailToSend.push(hash);
    }
  }

  selectAllUsers(selectAll: boolean) {
    if (selectAll) {
      this.filteredUsers.map((user) => {
        this.emailToSend.push(user.hash);
      });
      this.emailToSend = this.emailToSend.filter((element, index) => {
        return this.emailToSend.indexOf(element) === index;
      });
    } else {
      this.emailToSend = [];
    }
  }

  async sendEmailToUsers() {
    if (!this._authenticationService.hasCapability("send_multiple_welcome_email")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.emailToSend && this.emailToSend.length > 0) {
      let userWithNoEmail: string[] = [];
      this.emailToSend.map((hash: string) => {
        const user = this.userList.find((employee: any) => employee.hash === hash);
        if (!!user) {
          if (this.selectedCategory === "Email privata" && !user.private_email) {
            userWithNoEmail.push(user.complete_name);
          }
          if (this.selectedCategory === "Email aziendale" && !user.email) {
            userWithNoEmail.push(user.complete_name);
          }
        }
      });
      if (userWithNoEmail && userWithNoEmail.length > 0) {
        let employeeString = userWithNoEmail.join(", ");
        this._utilService.showSWALEmptyField({ text: `${await this._utilService.translate("ALERT.EMPLOYYE_WITH_NO_EMAIL")} ${employeeString}` });
        return false;
      }

      let employeesNames: string[] = [];
      this.emailToSend.map((hash: string) => {
        const user = this.userList.find((employee: any) => employee.hash === hash);
        if (!!user) {
          employeesNames.push(user.complete_name);
        }
      });
      const employeesNumber: number = this.emailToSend.length;
      let employeesJoin = employeesNames.join(", ");
      let confirmationText: string = `${await this._utilService.translate("ALERT.HAVE_SELECTED")} ${employeesNumber} ${
        this.emailToSend.length === 1 ? await this._utilService.translate("ALERT.EMPLOYEE") : await this._utilService.translate("ALERT.EMPLOYEES")
      }: ${employeesJoin}`;
      await this._utilService.showSWALDecision({ text: confirmationText, confirmButtonText: "CONFIRM_SEND_EMAIL" }).then(async (result) => {
        if (result.value) {
          let data = { users: this.emailToSend };
          this._utilService.showLoading();
          await this._userService
            .sendMultipleEmail(this.selectedCategory === "Email privata" ? "private" : "company", data)
            .then(async (response: { successes: string[]; errors: { hash: string; error: string }[] }) => {
              this.emailToSend = [];
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_MULTIPLE_EMAIL" });
              if (response.errors && response.errors.length > 0) {
                response.errors.map((err) => {
                  const user = this.userList.find((emp) => emp.hash === err.hash);
                  if (!!user) {
                    this.errorEmailNotSendedUsers.push(user.complete_name);
                  }
                });
              }
            })
            .catch(async (response: { successes: string[]; errors: { hash: string; error: string }[] }) => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_MULTIPLE_EMAIL" });
              if (response.errors && response.errors.length > 0) {
                response.errors.map((err) => {
                  const user = this.userList.find((emp) => emp.hash === err.hash);
                  if (!!user) {
                    this.errorEmailNotSendedUsers.push(user.complete_name);
                  }
                });
              }
            });
        } else if (result.isDismissed) {
          await this._utilService.showSWALInfo({
            text: "CANECEL_TEXT",
          });
        }
      });
    }
  }
}
